import { observer } from 'mobx-react';
import React, { useState } from 'react';

import { DataTable } from '../../../../design/dataTable/DataTable';
import { IAdminPageProperties } from '../../IAdminPageProperties';
import { SystemRoleAdminDomain } from './store/SystemRoleAdminDomain';

export interface ISystemRoleAdminTableProperties extends IAdminPageProperties { }

export const SystemRoleAdminTable = observer(({ layoutDomain }: ISystemRoleAdminTableProperties) => {
  const [domain] = useState<SystemRoleAdminDomain>(new SystemRoleAdminDomain(layoutDomain));

  return <DataTable dataTableDomain={domain} />;
});
